import posthog from "posthog-js";

/*
 * Shared PostHog client for all *.getlora.com microsites.
 *
 * Events route through this site's own origin (/ingest, rewritten in
 * vercel.json to the PostHog US cloud) so capture survives ad-blockers
 * and connect-src stays 'self'. The identity cookie is scoped to the
 * top-level domain, so visits across getlora.com subdomains resolve to
 * one person in the shared PostHog project.
 */
posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
  api_host: "/ingest",
  ui_host: "https://us.posthog.com",
  defaults: "2026-01-30",
  session_recording: { maskAllInputs: true },
});

/*
 * Referral attribution. UTM parameters and referrer are captured by
 * posthog-js itself; ?ref= share links are ours, so persist them: on
 * every event this session (super property) and on the person, where
 * initial_ref is set once and never overwritten by later visits.
 */
const ref = new URLSearchParams(window.location.search).get("ref");
if (ref) {
  posthog.register({ ref });
  posthog.setPersonProperties({ ref }, { initial_ref: ref });
}

export default posthog;
